import { RoutesEnum } from '~/constants/enums';
import { SvgIconType } from '@aqarmap/aqarmap-ui';

type ContextMenuItem = {
  name: string;
  url: RoutesEnum | string;
  iconName: SvgIconType;
};

export const contextActivitiesMenuItems: ContextMenuItem[] = [
  {
    name: 'savedProperties',
    url: RoutesEnum.FAVORITES,
    iconName: 'heart',
  },
];
